export default __webpack_public_path__ + "static/media/lieferheld_background_m2.33b834a4.jpg";